// extracted by mini-css-extract-plugin
export default {"highlight":"Highlight_highlight__SMQFC","img":"Highlight_img__2JWQu","title":"Highlight_title__taoPL","paragraph":"Highlight_paragraph__p3Skb"};